import { Typography, Checkbox, Stack, TextField } from '@mui/material';
const SettingsTab = ({ placeForm, setPlaceForm }) => (
  <Stack
    sx={{
      width: "100%",
      border: '1px solid var(--line)',
      borderRadius: '12px',
      background: '#f8fafc',
    }}
  >
    <Stack
      sx={{
        padding: '12px 16px',
        borderBottom: '1px solid var(--line)',
        background: '#fff',
      }}
    >
      <Typography>הגדרות מקום</Typography>
    </Stack>
    <Stack
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: '14px',
        padding: '14px 16px',
      }}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          gap: '8px',
          bgcolor: 'background.paper',
          borderRadius: 2,
          border: 1,
          borderColor: 'divider',
          padding: '9px 10px',
          minHeight: '42px',
        }}
      >
        <Checkbox
          checked={placeForm.isVerified}
          onChange={(e) =>
            setPlaceForm({
              ...placeForm,
              isVerified: e.target.checked,
            })
          }
        />{' '}
        מקום מאומת
      </Stack>

      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          gap: '8px',
          bgcolor: 'background.paper',
          borderRadius: 2,
          border: 1,
          borderColor: 'divider',
          padding: '9px 10px',
          minHeight: '42px',
        }}
      >
        <Checkbox
          checked={!placeForm.loadTrackingEnabled}
          onChange={(e) =>
            setPlaceForm({
              ...placeForm,
              loadTrackingEnabled: !e.target.checked,
              autoVisitDetectionEnabled: e.target.checked
                ? false
                : placeForm.autoVisitDetectionEnabled,
            })
          }
        />{' '}
        מקום ללא עומס
      </Stack>

      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          gap: '8px',
          bgcolor: 'background.paper',
          borderRadius: 2,
          border: 1,
          borderColor: 'divider',
          padding: '9px 10px',
          minHeight: '42px',
        }}
      >
        <Checkbox
          checked={placeForm.autoVisitDetectionEnabled}
          disabled={!placeForm.loadTrackingEnabled}
          onChange={(e) =>
            setPlaceForm({
              ...placeForm,
              autoVisitDetectionEnabled: e.target.checked,
            })
          }
        />{' '}
        מאושר לזיהוי ביקור אוטומטי
      </Stack>

      {placeForm.autoVisitDetectionEnabled && (
        <Stack>
          רדיוס Geofence במטרים
          <TextField
            type="number"
            min="100"
            max="1000"
            value={placeForm.autoVisitGeofenceRadiusMeters}
            onChange={(e) =>
              setPlaceForm({
                ...placeForm,
                autoVisitGeofenceRadiusMeters: e.target.value,
              })
            }
            fullWidth
          />
        </Stack>
      )}
    </Stack>
  </Stack>
);
export default SettingsTab;
